import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Zap, Factory, Car, Plane, ChevronRight } from 'lucide-react';
import { IMAGES } from '../utils/constants';

const ApplicationsSection = () => {
  return (
    <section id="applications" className="applications-section section-padding bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="section-header text-center mb-16">
          <h2 className="section-title">Applications</h2>
          <div className="title-underline" />
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Energy Storage & EV Safety */}
          <Card className="application-card">
            <div className="application-image-wrapper">
              <img src={IMAGES.evBattery} alt="Energy Storage & EV Safety" className="application-image" />
              <div className="application-overlay">
                <div className="application-icon-wrapper">
                  <Zap className="w-12 h-12" />
                </div>
              </div>
            </div>
            <CardContent className="p-8">
              <h3 className="application-title mb-4">Energy Storage & EV Safety</h3>
              <ul className="application-features space-y-3">
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Thermal runaway mitigation</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Cell-to-cell heat isolation</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Lightweight battery insulation</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Fire and heat shielding</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          {/* Industrial Thermal Insulation */}
          <Card className="application-card">
            <div className="application-image-wrapper">
              <img src={IMAGES.industrial} alt="Industrial Thermal Insulation" className="application-image" />
              <div className="application-overlay">
                <div className="application-icon-wrapper">
                  <Factory className="w-12 h-12" />
                </div>
              </div>
            </div>
            <CardContent className="p-8">
              <h3 className="application-title mb-4">Industrial Thermal Insulation</h3>
              <ul className="application-features space-y-3">
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>High-temperature equipment insulation</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Process energy loss reduction</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Compact insulation for constrained spaces</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Improved operational efficiency</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          {/* Mobility & Transportation */}
          <Card className="application-card">
            <div className="application-image-wrapper">
              <img src={IMAGES.transportation} alt="Mobility & Transportation" className="application-image" />
              <div className="application-overlay">
                <div className="application-icon-wrapper">
                  <Car className="w-12 h-12" />
                </div>
              </div>
            </div>
            <CardContent className="p-8">
              <h3 className="application-title mb-4">Mobility & Transportation</h3>
              <ul className="application-features space-y-3">
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>EV and hybrid vehicle insulation</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Lightweight thermal barriers</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Cabin and powertrain protection</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Enhanced vehicle safety</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          {/* Advanced Engineering */}
          <Card className="application-card">
            <div className="application-image-wrapper">
              <img src={IMAGES.aerospace} alt="Advanced Engineering" className="application-image" />
              <div className="application-overlay">
                <div className="application-icon-wrapper">
                  <Plane className="w-12 h-12" />
                </div>
              </div>
            </div>
            <CardContent className="p-8">
              <h3 className="application-title mb-4">Advanced Engineering</h3>
              <ul className="application-features space-y-3">
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Aerospace & defense insulation</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Extreme environment thermal control</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Lightweight protective systems</span>
                </li>
                <li className="feature-item">
                  <ChevronRight className="feature-check" />
                  <span>Mission-critical applications</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ApplicationsSection;
